import React from 'react';
import { createRoot } from 'react-dom/client';
import Program from '../pages/program/Program.jsx';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('program-ui');

    const root = createRoot(container);
    root.render(<Program />);
});
